import { render, staticRenderFns } from "./TablePurchaseOrderView.vue?vue&type=template&id=5364027c&scoped=true&"
import script from "./TablePurchaseOrderView.vue?vue&type=script&lang=js&"
export * from "./TablePurchaseOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364027c",
  null
  
)

export default component.exports